import getCharts from '../getCharts'
import { ImagingCRUD } from '../../constants/api.config'

export default async function ImagingInformation(
  Mode,
  Name = "",
  Priority = "",
  Keywords = "",
  imagingID = "",
  ReasonList = "",
  ExtraData = "",
  ImagingReason = "",
  ImagingCode = ""
) {
  try {
    const payload = {
      mode: Mode,
      Name,
      Priority,
      Keywords,
      imagingID,
      ReasonList,
      ExtraData,
      ImagingReason,
      ImagingCode
    }

    const res = await getCharts(ImagingCRUD, payload)
    return res.data

  } catch (error) {
    return error
  }
}